import { isDevEnv } from './is-dev-env'
import { checkLocalStorage } from './check-storage'

const showLogs = checkLocalStorage() ? window.localStorage.getItem('af-show-logs') === 'true' : false

export function logger(...message) {
    if (isDevEnv() || showLogs) {
        console.log('📋 ', ...message)
    }
}



// WEBPACK FOOTER //
// ./src/helpers/logger.js